export const consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 所属用户类型
  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 培训状态
  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,

  // 培训类型
  TYPE_ONLY_LEARNING: 1,
  TYPE_ONLY_EXAM: 2,
  TYPE_LEARNING_AND_EXAM: 3,

  // 考试状态
  EXAMINATION_STATUS_ONLINE: 2,
}

export const opts = {
  boolMaps: [
    {value: consts.TRUE, label: '是'},
    {value: consts.FALSE, label: '否'},
  ],
  statusMaps: [
    {value: consts.STATUS_NEW, label: '新创建'},
    {value: consts.STATUS_ONLINE, label: '已上架'},
    {value: consts.STATUS_OFFLINE, label: '已下架'},
  ],
  typeMaps: [
    {value: consts.TYPE_ONLY_LEARNING, label: '仅学习'},
    {value: consts.TYPE_ONLY_EXAM, label: '仅考试'},
    {value: consts.TYPE_LEARNING_AND_EXAM, label: '学习+考试'},
  ],
  targetUserMaps: [
    {value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false},
    {value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true},
  ],
  isCommonMaps: [
    {value: consts.IS_COMMON_DEDICATED, label: '专用'},
    {value: consts.IS_COMMON_SHARED, label: '通用'},
  ]
}

export const TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-list'



// WEBPACK FOOTER //
// ./src/views/training/training-instruction.constants.js